module.exports = __webpack_public_path__ + "media/src/assets/Images/Edit-faefbafcc920eda6887916831a454ca0.svg";